import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Modal } from '@/src/elements/modal/Modal'
import { Typography } from '@/src/elements/text/Typography'
import { getMeQueryOptions } from '@/src/features/auth/services/useMeQuery'
import { GENERAL_NOTIFICATION_SETTINGS } from '@/src/features/notification/models/notification.constants'
import { useNotificationSettingsMutation } from '@/src/features/notification/services/useNotificationSettingsMutation'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

type TWatchmanLeaveModalProps = {
  isOpen: boolean
  onClose: VoidFunction
}

export const WatchmanLeaveModal = ({ isOpen, onClose }: TWatchmanLeaveModalProps): ReactNode => {
  const { t } = useTranslate()
  const { push } = useRouter()
  const { routes } = useRoutes()
  const queryClient = useQueryClient()
  const { mutate: editNotificationSettings } = useNotificationSettingsMutation(
    GENERAL_NOTIFICATION_SETTINGS.ON_INTENTION_WATCHMAN,
  )

  const handleResign = () => {
    editNotificationSettings(
      { email: false, push: false },
      { onSuccess: () => queryClient.invalidateQueries({ queryKey: getMeQueryOptions().queryKey }) },
    )
    onClose()
    push(routes['prayer-space']())
  }

  return (
    <Modal
      showModal={isOpen}
      title={t('settings.notifications.watchman.title')}
      onCancel={onClose}
      classNames={{ body: 'overflow-visible' }}
    >
      <View className="gap-6 pt-2">
        <Typography className="text-center">{t('intention.prayer.watchman.commitment')}</Typography>
        <Typography bold className="text-center">
          {t('words.thank-you-very-much')}
        </Typography>
        <Button startIcon={ICON.LEAVE} colors="danger" variant="light" className="w-full" onPress={handleResign}>
          {t('intention.prayer.watchman.resign')}
        </Button>
      </View>
    </Modal>
  )
}
